import React from 'react'
import styled, { css } from 'styled-components'
import { color } from 'utils'

export enum TagType {
  DEFAULT = 'DEFAULT',
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}

export enum TagTheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT'
}

export enum TagSize {
  LARGE = 'LARGE',
  PRIMARY = 'PRIMARY'
}

const colorByTypeAndTheme = {
  [TagType.DEFAULT]: {
    [TagTheme.DARK]: css`
      color: ${color('white')};
      background-color: ${color('dark600')};
    `,
    [TagTheme.LIGHT]: css`
      color: ${color('dark900')};
      background-color: ${color('grey000')};
    `
  },
  [TagType.ERROR]: {
    [TagTheme.DARK]: css`
      color: ${color('dark900')};
      background-color: ${color('red400')};
    `,
    [TagTheme.LIGHT]: css`
      color: ${color('red600')};
      background-color: ${color('red100')};
    `
  },
  [TagType.INFO]: {
    [TagTheme.DARK]: css`
      color: ${color('blue400')};
      background-color: ${color('dark600')};
    `,
    [TagTheme.LIGHT]: css`
      color: ${color('blue600')};
      background-color: ${color('blue000')};
    `
  },
  [TagType.SUCCESS]: {
    [TagTheme.DARK]: css`
      color: ${color('dark900')};
      background-color: ${color('green400')};
    `,
    [TagTheme.LIGHT]: css`
      color: ${color('green600')};
      background-color: ${color('green000')};
    `
  },
  [TagType.WARNING]: {
    [TagTheme.DARK]: css`
      color: ${color('dark900')};
      background-color: ${color('warningMuted')};
    `,
    [TagTheme.LIGHT]: css`
      color: ${color('warning')};
      background-color: ${color('orange100')};
    `
  }
}

const sizes = {
  [TagSize.PRIMARY]: `font-size: 12px; padding: 4px 8px;`,
  [TagSize.LARGE]: `font-size: 14px; padding: 6px 12px;`
}

const StyledTag = styled.span<StyleProps>`
  ${({ colorTheme, type }) => colorByTypeAndTheme[type][colorTheme]}
  ${({ size }) => sizes[size]}
  border-radius: 4px;
  font-weight: 600;
  margin: 0.5rem 0.5rem 0.5rem 0px;
`

const Tag = ({
  children,
  theme = TagTheme.LIGHT,
  size = TagSize.PRIMARY,
  type = TagType.DEFAULT
}: Props) => (
  <StyledTag colorTheme={theme} type={type} size={size}>
    {children}
  </StyledTag>
)

type StyleProps = {
  colorTheme: TagTheme
  size: TagSize
  type: TagType
}

type Props = {
  children: React.ReactNode
  size?: TagSize
  theme?: TagTheme
  type?: TagType
}

export default Tag
